import { AfterViewInit, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from "@angular/core";
import { Router } from "@angular/router";
import { CouponInfoQr } from "@app/models";
import { PAGE_ROUTES } from "@app/pages/pages-routes";
import { SubscriptionManager } from "@app/shared-components";
import { CouponConfig } from "@app/shared/components";
import { TooltipManagerService } from "@app/shared/services";
import { PermissionTypeDto } from "clearline-api";
import { UserPermissionService } from "clearline-common";
import { SimplebarAngularComponent } from "simplebar-angular";

@Component({
  selector: "app-coupon-carousel",
  templateUrl: "./coupon-carousel.component.html",
  styleUrls: ["./coupon-carousel.component.scss"]
})
export class CouponCarouselComponent extends SubscriptionManager implements AfterViewInit {
  @Input() loading = true;
  @Input() withPreview = true;
  @Input() withNothingFoundText = false;
  @Input() viewType: "large" | "medium" | "small" = "large";
  @Input() selectionType: "single" | "multiple" = "multiple";
  @Input() couponSizeType: "standard" | "small" = "standard";
  @Input() centerSpinner = false;
  @Input() couponConfig?: CouponConfig;

  @Input() selectedCoupon: CouponInfoQr;
  @Input() coupons: Array<CouponInfoQr> = [];
  @Input() previewMode = false;
  @Input() rows: number;
  @Input() disabledNotActive: boolean;
  @Input() displayLoading = true;
  @Input() removeSelected = false;
  @Input() responsive = false;

  @Output() selectCoupon = new EventEmitter<CouponInfoQr>();
  @Output() qrCodeModalClosed = new EventEmitter<null>();

  @ViewChildren(SimplebarAngularComponent) simplebars: QueryList<SimplebarAngularComponent>;

  scrollbarOptions: any = {
    forceVisible: false,
    autoHide: false
  };

  private scrollHandler = () => this.tooltipManager.closeActiveTooltip();
  private attachedElements = new Set<HTMLElement>();

  constructor(private userPermissionService: UserPermissionService, private router: Router, private tooltipManager: TooltipManagerService) {
    super();
  }

  ngAfterViewInit(): void {
    this.attachScrollListeners(this.simplebars);
    this.sub = this.simplebars.changes.subscribe((list: QueryList<SimplebarAngularComponent>) => {
      this.attachScrollListeners(list);
    });
  }

  clickSelectCoupon(coupon: CouponInfoQr): void {
    this.selectCoupon.emit(coupon);
  }

  onCloseQrCodeModal(): void {
    this.qrCodeModalClosed.emit(null);
  }

  onUpgradeClick(permission: PermissionTypeDto) {
    const id = this.userPermissionService.lockedFeaturesMap.get(permission)?.id || 0;
    const upgradeUrl = `/${PAGE_ROUTES.MANAGER_PRICING_PLAN}?feature=${permission}`;

    this.router.navigateByUrl(`${upgradeUrl}${id > 0 ? `&plan=${id}` : ""}`).then();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.attachedElements.forEach((el) => el.removeEventListener("scroll", this.scrollHandler));
    this.attachedElements.clear();
  }

  private attachScrollListeners(list: QueryList<SimplebarAngularComponent>): void {
    list.forEach((simplebar) => {
      const scrollElement = simplebar.SimpleBar?.getScrollElement();
      if (scrollElement && !this.attachedElements.has(scrollElement)) {
        scrollElement.addEventListener("scroll", this.scrollHandler);
        this.attachedElements.add(scrollElement);
      }
    });
  }
}
